"use client";

import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import styled from "@mui/material/styles/styled"; // Local CUSTOM COMPONENTS

// import ProductReview from "./product-review";
import ProductDescription from "./product-description"; // STYLED COMPONENT
import { Product } from "src/lib/fetcher/client";
import SalifyFallback from "../../salify-fallback/default";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 0,
  marginBottom: 24,
  borderBottom: `1px solid ${theme.palette.text.disabled}`,
  "& .inner-tab": {
    fontWeight: 600,
    textTransform: "initial",
  },
}));

const ProductTabs: React.FC<{ product: Product }> = ({ product }) => {
  const [selectedOption, setSelectedOption] = useState(0);

  const handleOptionClick = (_: any, value: any) => setSelectedOption(value);

  return (
    <>
      <StyledTabs
        textColor="primary"
        value={selectedOption}
        indicatorColor="primary"
        onChange={handleOptionClick}
      >
        <Tab
          className="inner-tab"
          label={<SalifyFallback.Label path="Product Description" default="Mô tả sản phẩm" />}
        />
        <Tab
          className="inner-tab"
          label={<SalifyFallback.Label path="rating" default="Đánh giá" />}
        />
      </StyledTabs>

      <Box mb={6}>
        {selectedOption === 0 && <ProductDescription product={product} />}
        {/* {selectedOption === 1 && <ProductReview />} */}
      </Box>
    </>
  );
};

export default ProductTabs;
